import { QueryClient } from '@tanstack/react-query';

// D7: deliberate, non-default options. Library defaults retry failed queries
// and refetch on window focus; with fetchWithAuth a GET 5xx already routes to
// the global error page, so retry/focus-refetch would duplicate that routing
// and production traffic.
export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
    },
  });
}
